import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import { TextTiny } from '@awarego-ui/components';

/**
 * When a parent-partner manager views a distributor, show back link + breadcrumb.
 * Hidden for distributor-only admins (no access to the parent partner).
 */
function PartnerDistributorBackNav({ partnerId, sectionLabel }) {
    const { partnerStore, authStore } = useStores();

    useEffect(() => {
        if (partnerId) void partnerStore.loadSettings(partnerId);
    }, [partnerId, partnerStore]);

    const parentId = partnerStore.uiSettings?.parent_account_id;
    if (!parentId) return null;

    const canAccessParent = !!authStore.currentUser?.superForAccounts?.find(
        (p) => Number(p.id) === Number(parentId)
    );
    // Sub-partner admins must not see parent navigation
    if (!canAccessParent) return null;

    const parent = authStore.currentUser.superForAccounts.find(
        (p) => Number(p.id) === Number(parentId)
    );
    const current = partnerStore.currentPartner;
    const parentName = parent?.name || 'Partner';
    const distributorName = current?.name || 'Distributor';

    return (
        <div style={{ marginBottom: 8 }}>
            <Link to={`/partner/${parentId}/distributors`}>
                <div className="navigation back-button">
                    Back to Distributors
                </div>
            </Link>
            <TextTiny
                lighter
                displayBlock
                style={{ marginTop: 4, marginLeft: 2 }}
            >
                {parentName}
                {' / '}
                {distributorName}
                {sectionLabel ? ` / ${sectionLabel}` : ''}
            </TextTiny>
        </div>
    );
}

export default observer(PartnerDistributorBackNav);
